import React from 'react';

export function PromoArrowIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      aria-hidden
    >
      <path
        d="M6.54705 0L11.0481 4.53033L6.54705 9.06065L5.49485 7.96461L8.13997 5.33409H0V3.7704H8.18381L5.49485 1.12527L6.54705 0Z"
        fill="white"
      />
    </svg>
  );
}
